type CenteredLoadingProps = Readonly<{
  message?: string;
  muted?: boolean;
}>;

export function CenteredLoading({ message = "Loading orders...", muted = false }: CenteredLoadingProps) {
  return (
    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={muted ? { color: "var(--text-muted)" } : undefined}>{message}</p>
    </div>
  );
}

